export const TITLE = 'Application failed to launch';
export const TEXT = 'Sorry, it’s on us. Try again or contact our support team.';
export const TRY_AGAIN_BUTTON_TEXT = 'Try again';
export const OPEN_CHAT_WIDGET_BUTTON_TEXT = 'Contact support';
export const OPEN_CHAT_WIDGET_EVENT_NAME = 'Opened Chat Widget';
export const DEFAULT_ERROR_MESSAGE = 'Unexpected Error.';
